import { TDropdownItem, TInputTypes, TLiftedFormModel } from '../../model/form.model';
import { FORM_MODIFIER } from '../../model/form.modifier';
import { PIPELINE_FORM } from '../../model/form.pipeline';

type TReportIssueFormModelInput = {
  breakdownReasonsOptions: TDropdownItem[];
  solutionsOptions: TDropdownItem[];
  isAdditionalInfoRequired: boolean;
  isBreakdownReasonValid?: boolean;
  selectedBreakdownReason?: number;
  selectedSolution?: string;
  additionalInfo?: string;
};

const ADDITIONAL_INFO_MIN_LENGTH = 10;

export const REPORT_ISSUE_FORM_MODEL = {
  createModel: (
    reportIssueFormModelInput: TReportIssueFormModelInput,
    breakdownReasonOtherId: number,
  ): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            subType: 'number',
            options: reportIssueFormModelInput.breakdownReasonsOptions,
            isMulti: false,
            ...(reportIssueFormModelInput.selectedBreakdownReason
              ? { value: [reportIssueFormModelInput.selectedBreakdownReason] }
              : {}),
          },
          metadata: {
            keyName: 'breakdownReason',
            label: 'tm_report_issue.MachineIssue',
            isRequired: true,
            isValid: reportIssueFormModelInput.isBreakdownReasonValid,
          },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            options: reportIssueFormModelInput.solutionsOptions,
            isMulti: false,
            ...(reportIssueFormModelInput.selectedSolution
              ? { value: [reportIssueFormModelInput.selectedSolution] }
              : {}),
          },
          metadata: {
            keyName: 'solution',
            label: 'tm_report_issue.Solution',
          },
        },
        {
          input: {
            type: 'TEXTAREA',
            maxlength: 250,
            ...(reportIssueFormModelInput.isAdditionalInfoRequired ? { minlength: ADDITIONAL_INFO_MIN_LENGTH } : {}),
            value: reportIssueFormModelInput.additionalInfo,
          },
          metadata: {
            keyName: 'additionalInfo',
            label: 'tm_report_issue.AdditionalInfo',
            dependsOn: {
              keyName: 'breakdownReason',
              valuesCallback: (breakdownReasonVal: TInputTypes['value']) => {
                const [val] = breakdownReasonVal as [number];
                return {
                  updatedIsRequired:
                    val === breakdownReasonOtherId && reportIssueFormModelInput.isAdditionalInfoRequired,
                  textArea: {
                    updatedMinlength: getAdditionalInfoMinLength(
                      reportIssueFormModelInput.isAdditionalInfoRequired,
                      val,
                      breakdownReasonOtherId,
                    ),
                  },
                };
              },
            },
          },
        },
      ],
      colConfig: 'SINGLE_COL',
    });
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },
};

function getAdditionalInfoMinLength(
  isRequired: boolean,
  breakdownReason: number,
  breakdownReasonOtherId: number,
): number {
  return isRequired && breakdownReason === breakdownReasonOtherId ? ADDITIONAL_INFO_MIN_LENGTH : 0;
}
